import React from "react";
import styled from "styled-components";
import CustomModal from "./CustomModal";
import {
  DELETE_PROEJCT_USERS,
  DELETE_PROJECT,
  REMOVE_ACCOUNT,
  REMOVE_KEY,
  REMOVE_MEMBER,
  UNSUBSCRIBE,
  REACTIVATE_SUBSCRIPTION,
} from "../../constants/OptionsConstants";

const DeleteConfirmationChild = ({
  action,
  item,
  variant,
  disableButton,
  children,
  open,
  setOpen,
}) => {
  const handleClose = () => setOpen(false);

  const handleRemove = () => {
    action(item);
    setOpen(false);
  };

  const getTitle = (variant) => {
    switch (variant) {
      case REMOVE_ACCOUNT:
        return "Delete your account?";
      case DELETE_PROJECT:
        return "Delete this subscription?";
      case REMOVE_KEY:
        return "Delete this API key?";
      case REMOVE_MEMBER:
        return "Remove this member?";
      case DELETE_PROEJCT_USERS:
        return "Remove selected users?";
      case UNSUBSCRIBE:
        return "Cancel your subscription?";
      case REACTIVATE_SUBSCRIPTION:
        return "Reactivate subscription?";
      default:
        return "Are you sure?";
    }
  };

  const getDescription = (variant) => {
    switch (variant) {
      case REMOVE_ACCOUNT:
        return (
          <CenteredContent>
            <DescriptionText>
              This will permanently remove your account, all personal data,
              and revoke your access to the platform.
            </DescriptionText>
            <DescriptionText>This action cannot be undone.</DescriptionText>
          </CenteredContent>
        );
      case UNSUBSCRIBE:
        return (
          <CenteredContent>
            <DescriptionText>
              Canceling will stop future billing and end access to paid features at the end of your current billing period.
            </DescriptionText>
            <DescriptionText>You can reactivate anytime before your plan expires.</DescriptionText>
          </CenteredContent>
        );
      case REMOVE_MEMBER:
        return (
          <CenteredContent>
            <DescriptionText>Are you sure you want to remove this member?</DescriptionText>
            <DescriptionText>This action cannot be undone.</DescriptionText>
          </CenteredContent>
        );
      case REMOVE_KEY:
        return (
          <CenteredContent>
            <DescriptionText>
              Are you sure you want to delete this API key? You won't be able
              to access the API with it anymore.
            </DescriptionText>
            <DescriptionText>This action cannot be undone.</DescriptionText>
          </CenteredContent>
        );
      case DELETE_PROJECT:
        return (
          <CenteredContent>
            <DescriptionText>This will permanently remove the subscription, all data and all associated settings.</DescriptionText>
            <DescriptionText>Teammates will immediately lose access.</DescriptionText>
            <DescriptionText>This action cannot be undone.</DescriptionText>
          </CenteredContent>
        );
      case DELETE_PROEJCT_USERS:
        return (
          <CenteredContent>
            <DescriptionText>Are you sure you want to remove selected users?</DescriptionText>
            <DescriptionText>This action cannot be undone.</DescriptionText>
          </CenteredContent>
        );
      case REACTIVATE_SUBSCRIPTION:
        return (
          <CenteredContent>
            <DescriptionText>Are you sure you want to reactivate your subscription?</DescriptionText>
          </CenteredContent>
        );
      default:
        return (
          <CenteredContent>
            <DescriptionText>Are you sure you want to proceed?</DescriptionText>
          </CenteredContent>
        );
    }
  };

  const getConfirmText = (variant) => {
    switch (variant) {
      case REMOVE_ACCOUNT:
        return "Delete Account";
      case DELETE_PROJECT:
        return "Delete Subscription";
      case REMOVE_KEY:
        return "Delete Key";
      case REMOVE_MEMBER:
        return "Remove Member";
      case DELETE_PROEJCT_USERS:
        return "Remove Users";
      case UNSUBSCRIBE:
        return "Cancel Subscription";
      case REACTIVATE_SUBSCRIPTION:
        return "Yes, Reactivate";
      default:
        return "Confirm";
    }
  };

  const WarningIcon = (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8.5V12.5M12 16.5H12.01M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );

  return (
    <>
      {children}
      <CustomModal
        isOpen={open}
        onOpenChange={setOpen}
        iconType="warning"
        title={getTitle(variant)}
        titleAlignment="center"
        zIndex={2000}
        buttons={[
          {
            text: "Cancel",
            variant: "secondary",
            onClick: handleClose,
          },
          {
            text: getConfirmText(variant),
            variant: "delete",
            onClick: handleRemove,
            disabled: disableButton,
          },
        ]}
      >
        {getDescription(variant)}
      </CustomModal>
    </>
  );
};

export default DeleteConfirmationChild;

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const DescriptionText = styled.p`
  color: #667085;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;
